'use strict'

import $ from 'jquery'

export default class StickyNav{
  constructor($el){
    this.$el = $($el)
    this.fixedClass = 'sticky-nav--pinned'
    this.$elementTop = this.$el.offset().top
    this.activeSection = 'active-section'
    this.accordion = this.$el.find('.sticky-nav__accordion')
    this.$elementHeight = this.$el.height()
    this.$list = this.$el.find('ul')
    this.anchorArray = []
    this.click()

    this.$el.find('.accordion__content a').each((i,v) => {
      const linkCheck = $(v).attr('href').match('/')
      if(!linkCheck > 0){
        this.anchorArray.push($(v).attr('href'))
      } 
    })
    this.scrollChange(this.anchorArray)
    $(document).on({
      'scroll.scrollChange': ()=> {
        this.scrollChange(this.anchorArray)
      }
    })
    this.$el.find('#toggle-accordion-anchor').on('click', (e)=> {
      e.preventDefault()
      const dropdown = $('.accordion__content')
      if ($(this.accordion).hasClass('accordion-open')) {
        $(this.accordion).removeClass('accordion-open')
        dropdown.attr('aria-hidden', true)
      } else {
        $(this.accordion).addClass('accordion-open')
        dropdown.attr('aria-hidden', false)
      }
    })
    this.$el.find('.accordion__content a').on('click', (e)=> {
      const dropdown = $('.accordion__content')
      if ($(this.accordion).hasClass('accordion-open')) {
        $(this.accordion).removeClass('accordion-open')
        dropdown.attr('aria-hidden', true)
      }
    })
    // create the ID array
    // run on page load for any already in view or past being in view
    this.scrollChangeBottom($(window).height())
    // run on page scroll to verify if element should be shown yet
    $(document).on({
      'scroll.stickyScroll': ()=> {
        this.scrollChangeBottom($(window).height())
      }
    })

  }
  click(){
    this.$list.find('a').click((e) => {
      this.$el.addClass(this.fixedClass)
      let target = $(e.currentTarget.hash)
      if(typeof target.offset() !== 'undefined'){ 
        e.preventDefault()
        $('.' + this.activeSection).removeClass(this.activeSection)
        $(e.currentTarget).addClass(this.activeSection)
      }
    })
  }
  scrollChange(array) {
    if(!this.$el.hasClass('sticky-nav--pinned')){
      this.textUpdate(true)
      this.$el.find('.sticky-nav__items a').removeClass(this.activeSection)
    }
    for (let a = 0; a < array.length; a++) {
      const idSelector = $('' + array[a] + '')
      
      if(idSelector.length > 0){
        const panelOffset = idSelector.offset().top
        const panelHeight = idSelector.height()
        const windowTop = window.pageYOffset
        if (window.pageYOffset === 0) {
          this.textUpdate(true)
          this.$el.find('.sticky-nav__items a').removeClass(this.activeSection)
          this.$el.find('.accordion__content a').removeClass(this.activeSection)
        } else if (
          windowTop === panelOffset ||
          windowTop >= panelOffset - 100 &&
          windowTop <= (panelOffset + panelHeight) + 100
        ) {
          const currentID = idSelector.attr('id')
          if ($(window).width() < 1000) {
            const currentSelector = this.$el.find('.accordion__content > a[href="#' + currentID + '"]')
            this.$el.find('.accordion__content a').removeClass(this.activeSection)
            this.textUpdate(false, currentSelector.text())
            currentSelector.addClass(this.activeSection)
          } else {
            const currentSelector = this.$el.find('a[href="#' + currentID + '"]')
            this.$el.find('.sticky-nav__items a').removeClass(this.activeSection)
            currentSelector.addClass(this.activeSection)
          }
        }
      }
    }
  }
  // check if element is past its location in the document
  scrollChangeBottom(){
    const windowTop = window.pageYOffset
    const globalHeader = $('.global-header')
    const banner = $('.global-header__banner')
    const navTitle = $('.sticky-nav__title h4')
    let globalHeaderHeight = globalHeader.outerHeight()
    
    // Checks to see if Anchor is aligned with window top
    if ((windowTop) === this.$elementTop - (globalHeaderHeight) || (windowTop) >= this.$elementTop - (globalHeaderHeight) ){
      // If so, hide header & promo banner when Anchor is at top of window} 
      globalHeader.addClass('slide-up').removeClass('slide-down')
      banner.addClass('slide-up').removeClass('slide-down')
    } else {
      // Redisplay header & banner when scrolling back to top
      globalHeader.addClass('slide-down').removeClass('slide-up')
      banner.addClass('slide-down').removeClass('slide-up')
      if ($('.accordion-open')) {
        $('.accordion-open').removeClass('accordion-open')
      }
    }
    // when the page offset is higher than the element tracking add a class
    if ((windowTop) === this.$elementTop || (windowTop) >= this.$elementTop - 2) {
      navTitle.addClass('slide-in')
      this.$el.addClass(this.fixedClass)
    } else {
      // otherwise remove the class
      navTitle.removeClass('slide-in')
      this.$el.removeClass(this.fixedClass)
    }
  }
  textUpdate(reset, text){
    const accordionButton = $('#toggle-accordion-anchor')
    if(!reset){
      accordionButton.html(text)
    } else {
      accordionButton.html('Scroll to Section')
    }
  }
}
